import AnalyticsBase from './AnalyticsBase';
import { ApiBooking } from '@ibe/api';

class TravelDetailsEvent extends AnalyticsBase {
  amountTravellers: number | null;

  hotel: string | null;

  amountRooms: number | null;

  mealDescription: string | null;

  booking: ApiBooking | null;

  step: string | null;

  duration: number | null;
}

export default TravelDetailsEvent;
